import Notification from "../../../components/Common/Notification/index";
import * as pantApi from "../../../services/pant";
import {
  ADD_PANT_FAILURE,
  ADD_PANT_REQUEST,
  ADD_PANT_SUCCESS,
  DELETE_PANT_FAILURE,
  DELETE_PANT_REQUEST,
  DELETE_PANT_SUCCESS,
  GET_PANTS_FAILURE,
  GET_PANTS_REQUEST,
  GET_PANTS_SUCCESS,
  GET_SINGLE_PANT_FAILURE,
  GET_SINGLE_PANT_REQUEST,
  GET_SINGLE_PANT_SUCCESS,
  UPDATE_PANT_FAILURE,
  UPDATE_PANT_REQUEST,
  UPDATE_PANT_SUCCESS,
} from "./pant.actionType";

export const requestAddPant = () => {
  return {
    type: ADD_PANT_REQUEST,
  };
};

export const addPantSuccess = (data) => {
  return {
    type: ADD_PANT_SUCCESS,
    data,
  };
};

export const addPantFailure = (message) => {
  return {
    type: ADD_PANT_FAILURE,
    message,
  };
};

export const addPant = (data) => {
  return (dispatch) => {
    dispatch(requestAddPant());
    return pantApi
      .addPant(data)
      .then((resp) => {
        const data = resp.data;
        dispatch(addPantSuccess(data));
        return data
      })
      .catch((err) => {
        const errorMessage = err.response && err.response.data.message;
        dispatch(addPantFailure());
        Notification("", errorMessage, "error");
        throw errorMessage;
      });
  };
};

export const requestGetPants = () => {
  return {
    type: GET_PANTS_REQUEST,
  };
};

export const getPantsSuccess = (data) => {
  return {
    type: GET_PANTS_SUCCESS,
    data,
  };
};

export const getPantsFailure = (message) => {
  return {
    type: GET_PANTS_FAILURE,
    message,
  };
};

export const getPants = () => {
  return (dispatch) => {
    dispatch(requestGetPants());
    return pantApi
      .getPants()
      .then(async (resp) => {
        const data = resp.data;
        await dispatch(getPantsSuccess(data));
        return data;
      })
      .catch((err) => {
        const errorMessage = err.response && err.response.data.message;
        dispatch(getPantsFailure());
        if (errorMessage === "Invalid token.") {
          return Notification("आपला सांकेतिक माहिती चुकली आहे ", "", "error");
        }
        Notification("", errorMessage, "error");
      });
  };
};

export const requestgetSinglePant = () => {
  return {
    type: GET_SINGLE_PANT_REQUEST,
  };
};

export const getSinglePantSuccess = (data) => {
  return {
    type: GET_SINGLE_PANT_SUCCESS,
    data,
  };
};

export const getSinglePantFailure = (message) => {
  return {
    type: GET_SINGLE_PANT_FAILURE,
    message,
  };
};

export const getSinglePant = (id) => {
  return (dispatch) => {
    dispatch(requestgetSinglePant());
    return pantApi
      .getSinglePant(id)
      .then((resp) => {
        const data = resp.data;
        dispatch(getSinglePantSuccess(data));
        return;
      })
      .catch((err) => {
        const errorMessage = err.response && err.response.data;
        dispatch(getSinglePantFailure());
        return Notification("", errorMessage, "error");
      });
  };
};

export const requestDeletePant = () => {
  return {
    type: DELETE_PANT_REQUEST,
  };
};

export const deletePantSuccess = (data) => {
  return {
    type: DELETE_PANT_SUCCESS,
    data,
  };
};

export const deletePantFailure = (message) => {
  return {
    type: DELETE_PANT_FAILURE,
    message,
  };
};

export const deletePant = (id) => {
  return (dispatch) => {
    dispatch(requestDeletePant());
    return pantApi
      .deletePant(id)
      .then((resp) => {
        const data = resp.data;
        dispatch(deletePantSuccess(data));
        return Notification(data?.name, `यशस्वीरित्या हटविले गेले.`, "success");
      })
      .catch((err) => {
        const errorMessage =
          (err?.response && err?.response?.data?.message) ||
          "काहीतरी चूक झाली कृपया पुन्हा प्रयत्न करा";
        dispatch(deletePantFailure());
        return Notification("", errorMessage, "error");
      });
  };
};

export const requestUpdatePant = () => {
  return {
    type: UPDATE_PANT_REQUEST,
  };
};

export const updatePantSuccess = (data) => {
  return {
    type: UPDATE_PANT_SUCCESS,
    data,
  };
};

export const updatePantFailure = (message) => {
  return {
    type: UPDATE_PANT_FAILURE,
    message,
  };
};

export const updatePant = (id, data) => {
  return (dispatch) => {
    dispatch(requestUpdatePant());
    return pantApi
      .updatePant(id, data)
      .then((resp) => {
        const data = resp.data;
        dispatch(updatePantSuccess(data));
      })
      .catch((err) => {
        const errorMessage =
          (err?.response && err?.response?.data?.message) ||
          "काहीतरी चूक झाली कृपया पुन्हा प्रयत्न करा";
        dispatch(updatePantFailure());
        Notification("", errorMessage, "error");
      });
  };
};
